import { useNavigate } from "react-router-dom";
import { IconFileDescription, IconLock } from "@tabler/icons-react";
import { EmptyState } from "../../../../components/common/empty-state";
import { AppRoutes } from "../../../../common/routes/app_routes";

/**
 * Shown instead of the checkout to buyers whose prices are hidden (documents
 * not approved yet): they'd otherwise be placing an order without ever seeing
 * the amount. The backend refuses the payment for them too — this is the
 * explanation, not the guard.
 */
export function CheckoutLockedView() {
  const navigate = useNavigate();

  return (
    <div className="flex w-full flex-col items-center px-8 py-6">
      <EmptyState
        icon={IconLock}
        title="Ordering unlocks once your account is approved"
        description="Prices stay hidden until your CR and Tax Card are approved — usually within 1–2 business days — so orders can't be placed yet. Your cart and quotations are saved."
        primaryAction={{
          label: "View my documents",
          leftIcon: <IconFileDescription size={16} />,
          onClick: () => navigate(`${AppRoutes.ACCOUNT}?tab=documents`),
        }}
        secondaryAction={{
          label: "Continue browsing",
          onClick: () => navigate(AppRoutes.PRODUCTS),
        }}
        actionable={false}
        className="w-full rounded-2xl border border-borderDefault bg-bgWhite"
      />
    </div>
  );
}
